import { EnvironmentProviders, inject, provideEnvironmentInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { registerCustomSvgIcons } from './register-custom-svg-icons';

export function provideCustomSvgIconRegistry(): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    const matIconRegistry: MatIconRegistry = inject(MatIconRegistry);
    const domSanitizer: DomSanitizer = inject(DomSanitizer);

    registerCustomSvgIcons(matIconRegistry, domSanitizer);
  });
}
